import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage.js";
import Estoque from "./pages/Estoque.js";
import VeiculoClient from "./pages/Veiculo.js";
import WhatsappFloatButton from "./components/WhatsappFloatButton.js";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/estoque" element={<Estoque /> } />
          <Route path="/veiculo/:idVeiculo" element={<VeiculoClient />}/>
        </Routes>
        <WhatsappFloatButton />
      </BrowserRouter>
    </div>
  );
}

export default App;